<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <!-- formulario -->
    <v-row justify="center">
      <v-col cols="12" sm="10" lg="8">
        <v-card outlined elevation="2" :loading="loadingForm">
          <v-card-title class="justify-center">
            <p class="text-h4 font-weight-bold primary--text mt-2">
              Importar Usuarios
            </p>
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col 
                cols="12" 
                sm="10" 
                lg="8"
              >
                <v-form 
                  ref="form" 
                  v-model="form"
                >
                  <v-row justify="center">
                    <v-col cols="11">
                      <v-file-input
                        outlined
                        dense
                        prepend-icon=""
                        append-icon="mdi-paperclip"
                        accept=".xlsx"
                        label="Importar archivo excel"
                        truncate-length="100"
                        counter
                        show-size
                        v-model="usuarios"
                        :rules="archivoReglas"
                      >
                      </v-file-input>
                    </v-col>

                    <v-col cols="1">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            medium
                            color="primary"
                            class="mt-2"
                            v-bind="attrs"
                            v-on="on"
                            @click="descargarPlantillaUsuarios"
                          >
                            mdi-cloud-download
                          </v-icon>
                        </template>
                        <span>Descargar Plantilla</span>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="12">
                      <v-btn
                        block
                        large
                        exact
                        elevation="2"
                        color="primary"
                        class="mb-6"
                        @click="importarUsuarios()"
                      >
                        Importar Archivo
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Alert from "../../../components/admin/Alert.vue";

export default {
  data: () => ({
    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    form: true,
    loadingForm: false,

    usuarios: null,
    archivoReglas: [
      (v) => !!v || "Seleccione un archivo excel"
    ],
  }),

  components: {
    Alert,
  },

  methods: {
    importarUsuarios() {
      if (this.$refs.form.validate()) {
        this.loadingForm = true;

        this.$store.dispatch("importarUsuarios", this.usuarios)
        .then((response) => {
          if (response.status == "success") {
            this.loadingForm = false;

            this.alertType    = "success--text";
            this.alertTitle   = "Importados";
            this.alertMessage = response.message;
            this.alert        = true;

            setTimeout(() => {
              this.alert = false
              this.$router.replace({ name: 'usuario-gestionar' })
            }, 2000)
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";
            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }
            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }
    },

    descargarPlantillaUsuarios() {
      this.$store.dispatch("descargarPlantilla", 'usuario')
      .then((response) => {
        const urlPlantilla = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = urlPlantilla;
        link.setAttribute("download", "Plantilla-Usuarios.xlsx");
        document.body.appendChild(link);
        link.click();
      });
    },
  },
};
</script>